<template>
  <div class="squizzy-squid" >
    <img style="max-width: 200px;
    max-height: 139px;
    width: auto;
    height: auto;" :src="image">
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      default:  require("@/assets/tuni-logo.gif")
    },
    mouth: {
      type: String,
      default: "default"
    }
  }
};
</script>

<style type="text/css" lang="css">
  .st0{fill:#CEE1F4;}
  .st1{fill:#78A0CF;}
  .st2{fill:#F1BC19;}
  .st3{fill:#FBCD59;}
  .st4{fill:#FFFFFF;}
  .st5{fill:#A31E23;}
  .st6{fill:#DE1F26;}
  .st7{fill:#D21D4F;}
  .st8{fill:#E74525;}
  .st9{fill:#EA6924;}
  .st10{fill:#C52127;}
  .st11{fill:#902579;}
  .st12{fill:#E41F26;}
  .st13{fill:#F29120;}
  .st14{fill:#F8B916;}
  .st15{fill:#E40780;}
  .st16{fill:#B71E78;}
  .st17{fill:#751A54;}
  .st18{fill:#562B7A;}
  .st19{fill:#FDDA00;}
  .st20{fill:#FDED07;}
  .st21{fill:#EB6FA7;}
  .st22{fill:#874E94;}
  .st23{fill:#2B3580;}
  .st24{fill:#512B7A;}
  .st25{fill:#A4C539;}
  .st26{fill:#0FA04A;}
  .st27{fill:#76B743;}
  .st28{fill:#21A2DC;}
  .st29{fill:#70BC84;}
  .st30{fill:#64B046;}
  .st31{fill:#26265E;}
  .st32{fill:#3F487D;}
  .st33{fill:#1565AD;}
  .st34{fill:#15B0A4;}
  .st35{fill:#23AFE5;}
  .st36{fill:#6FB164;}
  .st37{fill:#59C6F1;}
  .st38{fill:#19B09D;}
  .st39{fill:#6DB063;}
  .st40{fill:#6DBD83;}
  .st41{fill:#65C0BD;}
  .st42{fill:#0A7BC0;}
  .st43{fill:#85CEF2;}
  .st44{font-family:'Asap';}
  .st45{font-size:67px;}
  .st00{fill:#EFEFEF;}
  .st01{fill:#55965C;}
  .st02{fill:#73C97C;}
  .st03{fill:#FF675B;}
  .st04{fill:#A3A3A3;}
  .st05{fill:#707070;}
  .st06{fill:#FFD04A;}
</style>
<style lang="sass" scoped>
.squizzy-squid
  display: flex
  justify-content: center
  text-align: center
  margin: 0.5rem auto
  max-height: 180px
  height: 100%
  @media screen and (max-width: 320px)
    max-height: 90px
  & svg
    width: 100%

#body
  transform-origin: 50% 50%
  animation: float 4s infinite ease-in-out forwards

#body-background
  transform-origin: 50% 50%
  animation: background 3s 0.5s infinite ease-in-out forwards

@keyframes float
  0%, 100%
    transform: translateY(5px) rotate(10deg) scale(0.95)
  50%
    transform: translateY(-5px) rotate(10deg) scale(0.95)

@keyframes background
  0%, 100%
    transform: scale(1) rotate(0deg)
  50%
    transform: scale(0.95) rotate(-10deg)
</style>
